/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from '@/lib/api';

// Config & limits
export const getTelemedicineConfig = () => api.get('/telemedicine/config').then(r => r.data);
export const getMyLimits = () => api.get('/telemedicine/limits').then(r => r.data);

// Doctor profile
export const getMyDoctorProfile = () => api.get('/telemedicine/doctor/me').then(r => r.data);
export const updateMyDoctorProfile = (payload) => api.put('/telemedicine/doctor/me', payload).then(r => r.data);

// Doctor availability & slots
export const getMyAvailability = () => api.get('/telemedicine/doctor/availability').then(r => r.data);
export const updateMyAvailability = (payload) => api.put('/telemedicine/doctor/availability', payload).then(r => r.data);
export const getDoctorSlots = (doctorId, date) => api.get(`/telemedicine/doctors/${doctorId}/slots`, { params: { date } }).then(r => r.data);

// Marketplace
export const listSpecialties = () => api.get('/telemedicine/specialties').then(r => r.data);
export const listDoctors = (only_active = true) => api.get('/telemedicine/doctors', { params: { only_active } }).then(r => r.data);
export const getDoctor = (id) => api.get(`/telemedicine/doctors/${id}`).then(r => r.data);

// Subscriptions & Premium
export const createSubscriptionCheckout = (origin_url) => api.post('/telemedicine/subscription/checkout', { origin_url }).then(r => r.data);
export const createPatientPremiumCheckout = (origin_url) => api.post('/telemedicine/patient/premium/checkout', { origin_url }).then(r => r.data);

// Stripe Connect
export const startConnectOnboarding = (origin_url) => api.post('/telemedicine/doctor/connect/onboard', { origin_url }).then(r => r.data);
export const getConnectStatus = () => api.get('/telemedicine/doctor/connect/status').then(r => r.data);
export const getConnectDashboardLink = () => api.post('/telemedicine/doctor/connect/dashboard').then(r => r.data);

// Appointments
export const bookAppointment = (payload) => api.post('/telemedicine/appointments', payload).then(r => r.data);
export const listMyAppointments = (role) => api.get('/telemedicine/appointments', { params: role ? { role } : {} }).then(r => r.data);
export const getAppointment = (id) => api.get(`/telemedicine/appointments/${id}`).then(r => r.data);
export const getVideoRoom = (id) => api.get(`/telemedicine/appointments/${id}/room`).then(r => r.data);
export const startVisit = (id) => api.post(`/telemedicine/appointments/${id}/start-visit`).then(r => r.data);
export const endVisit = (id) => api.post(`/telemedicine/appointments/${id}/end-visit`).then(r => r.data);

// Clinical notes
export const addClinicalNote = (id, payload) => api.post(`/telemedicine/appointments/${id}/notes`, payload).then(r => r.data);
export const listClinicalNotes = (id) => api.get(`/telemedicine/appointments/${id}/notes`).then(r => r.data);
export const getPatientHistory = (patientId) => api.get(`/telemedicine/patients/${patientId}/history`).then(r => r.data);

// Payment status
export const getPaymentStatus = (session_id) => api.get(`/payments/status/${session_id}`).then(r => r.data);
